<script>
import { authComputed, merchantUserComputed } from '@state/helpers'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'
import AdminForm from './AdminForm'
import PermissionTable from './PermissionTable'

import pageMixin from '@src/mixins/pagination'

export default {
  page: {
    title: '商店管理帳號',
    meta: [{ name: 'description', content: 'Admin List' }],
  },
  components: { Layout, BaseButtonDialog, AdminForm, PermissionTable },
  mixins: [pageMixin],
  data() {
    return {
      editDialogVisible: false,
      editDialogMode: 'add', // edit 編輯, add 新增'
      editDialogItem: {},
      permissionDialogVisible: false,
      filterData: {
        groupIds: [],
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantUserComputed,
    editDialogTitle() {
      return this.editDialogMode === 'add' ? '新增管理帳號' : '編輯管理帳號'
    },
  },
  watch: {
    currentPage: {
      handler: 'tryToSearchUser',
      immediate: true,
    },
  },
  mounted() {
    this.$refs.table.doLayout()
  },
  methods: {
    openEditDialog(mode, userData) {
      this.editDialogVisible = true
      this.editDialogMode = mode
      this.editDialogItem = userData
    },
    closeEditDialog() {
      this.editDialogVisible = false
      this.resetEditDialog()
    },
    updateList() {
      this.tryToSearchUser()
      this.closeEditDialog()
    },
    async tryToSearchUser() {
      const total = await this.$store.dispatch(
        'merchant/fetchUsers',
        Object.assign(this.filterData, this.pageQuery)
      )

      this.$nextTick(() => {
        this.$refs.pagination.updateTotal(total)
      })
    },
    resetEditDialog() {
      this.editDialogMode = 'add'
      this.editDialogItem = {}
    }
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader title="商店管理帳號" />
    <BaseTableSearch v-slot="{ fields }" :default-value="filterData" @reset="tryToSearchUser">
      <el-form-item prop="groupIds">
        <el-select
          v-model="fields.groupIds"
          multiple
          placeholder="選擇帳號身份"
          @change="tryToSearchUser"
        >
          <el-option
            v-for="group in userGroupList"
            :key="group.id"
            :label="group.title"
            :value="group.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </BaseTableSearch>
    <el-table :data="userList" ref="table">
      <el-table-column v-slot="{ row }" label="姓名／Email" width="300">
        {{ row.firstName }} {{ row.lastName }}
        <div>{{ row.email }}</div>
      </el-table-column>
      <el-table-column
        v-for="group in userGroupList"
        v-slot="{ row }"
        :key="group.id"
        :label="group.title"
        align="center"
      >
        <BaseIcon v-if="row.groupIds.includes(group.id)" name="check-circle" class="only-icon" />
      </el-table-column>
      <el-table-column v-slot="{ row }" align="right">
        <el-button size="mini" @click="openEditDialog('edit', row)">
          <BaseIcon name="edit" />
        </el-button>
      </el-table-column>
    </el-table>
    <BasePagination ref="pagination" :current-page.sync="currentPage" />
    <BaseButtonDialog
      v-can:api="'addAdmin'"
      title="身份與權限表"
      :dialog-visible.sync="permissionDialogVisible"
      :dialog-props=" { width: '70%' }"
      button-type="info"
      button-icon-name="info"
      order="2"
      floating
    >
      <PermissionTable show-owner />
    </BaseButtonDialog>

    <BaseButtonDialog
      :only-dialog="!$can('api','addAdmin')"
      :title="editDialogTitle"
      :dialog-visible.sync="editDialogVisible"
      :dialog-props="{ width: '70%' }"
      floating
      @closed="resetEditDialog"
      :destroy="true"
    >
      <AdminForm :default-value="editDialogItem" @close="closeEditDialog" @store="updateList" />
    </BaseButtonDialog>
  </Layout>
</template>


